var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cube-2",
    transform: "translate(-293.000000, -91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cube",
    transform: "translate(69.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Share",
    transform: "translate(44.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(180.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Circle-Color",
    fill: "#FFFFFF",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 12.000000)",
    fill: "#051C2C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,5 C19.3281424,5 20,5.67185763 20,6.5 L20,17.5 C20,18.3281424 19.3281424,19 18.5,19 L5.5,19 C4.67185763,19 4,18.3281424 4,17.5 L4,6.5 C4,5.67185763 4.67185763,5 5.5,5 L18.5,5 Z M18.5,6 L5.5,6 C5.22414237,6 5,6.22414237 5,6.5 L5,17.5 C5,17.7758576 5.22414237,18 5.5,18 L18.5,18 C18.7758576,18 19,17.7758576 19,17.5 L19,6.5 C19,6.22414237 18.7758576,6 18.5,6 Z M17.1833811,8.11302135 C17.3971035,7.93815756 17.7121149,7.9696587 17.8869786,8.1833811 C18.0618424,8.39710351 18.0303413,8.71211486 17.8166189,8.88697865 L17.8166189,8.88697865 L12.3166189,13.3869786 C12.132436,13.5376738 11.867564,13.5376738 11.6833811,13.3869786 L11.6833811,13.3869786 L6.1833811,8.88697865 C5.9696587,8.71211486 5.93815756,8.39710351 6.11302135,8.1833811 C6.28788514,7.9696587 6.60289649,7.93815756 6.8166189,8.11302135 L6.8166189,8.11302135 L12,12.3539695 Z",
    id: "Email"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f381eaeaf570fc6755f6440097b67cb8.svg";
export { ForwardRef as ReactComponent };